<form-layout [showSave]="false" (onSave)="onSaveClick()" (onBack)="onBackClick()" (onNext)="onSaveAndNextClick()">
  <div>
    <kendo-grid [data]="gridView" (remove)="removeHandler($event)" (edit)="editHandler($event)" [sort]="sort"
      [sortable]="true">

      <kendo-grid-column title="{{'schedule-data.grid.subject' | translate}}" field="betreff" [width]="200">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <div *ngIf="dataItem?.betreff != null || dataItem?.betreff != ''" [attr.id]="'rowheader-' + rowIndex">
            <span>
              {{ dataItem.betreff }}
            </span>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="{{'schedule-data.grid.datePlan' | translate}}" field="datumPlan" [width]="100"
        editor="date">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <div *ngIf="dataItem?.datumPlan != null" [attr.aria-labelledby]="'rowheader-' + rowIndex">
            <span>
              {{ dataItem?.datumPlan | date: languageService.GetCurrentShortDateFormat() }}
            </span>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="{{'schedule-data.grid.dateActual' | translate}}" field="datumIst" [width]="100"
        editor="date">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <div *ngIf="dataItem?.datumIst != null" [attr.aria-labelledby]="'rowheader-' + rowIndex">
            <span>
              {{ dataItem?.datumIst | date: languageService.GetCurrentShortDateFormat() }}
            </span>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="{{'schedule-data.grid.location' | translate}}" field="ort" [width]="150">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <div *ngIf="dataItem?.ort != null || dataItem?.ort != ''" [attr.aria-labelledby]="'rowheader-' + rowIndex">
            <span>
              {{ dataItem.ort }}
            </span>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="{{'schedule-data.grid.description' | translate}}" field="beschreibung" [width]="250">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <div *ngIf="dataItem?.beschreibung != null || dataItem?.beschreibung != ''" [attr.aria-labelledby]="'rowheader-' + rowIndex">
            <span>
              {{ dataItem.beschreibung }}
            </span>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-command-column [width]="155" *ngIf="!formGroup.disabled">
        <ng-template kendoGridCellTemplate let-isNew="isNew" let-rowIndex="rowIndex">
          <button kendoGridEditCommand [title]="'schedule-data.dialog.titleEdit' | translate"
            class="confirm-button" [attr.aria-labelledby]="'rowheader-' + rowIndex + ' edit-label'">
            <i class="fa fa-pen"></i>
          </button>

          <button kendoGridRemoveCommand [title]="'schedule-data.dialog.titleDelete' | translate"
            class="cancel-button" [attr.aria-labelledby]="'rowheader-' + rowIndex + ' delete-label'">
            <i class="fa fa-trash"></i>
          </button>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>

  <div class="mt-4">
    <button kendoButton class="confirm-button" (click)="createHandler()" *ngIf="!formGroup.disabled && !isFormOpen">
      <span translate>schedule-data.grid.add</span>
      <i class="fa fa-plus" style="margin-left: 0.5rem;"></i>
    </button>
  </div>

  <form [formGroup]="milestoneForm" *ngIf="isFormOpen">
    <div class="mile-stone-grid">
      <kendo-formfield class="text" showHints="initial">
        <kendo-label class="form-label" text="{{'schedule-data.dialog.subject' | translate}} *"
          [infotooltip]="'meilenstein.betreff'" [for]="betreff"></kendo-label>
        <kendo-textbox #betreff formControlName="betreff" appinfotext="betreff" [maxlength]="200"
          [appinfotext]="'meilenstein.betreff'" [disabled]="isUpdatedInProjektBericht"
          (paste)="this.textBoxService.onPaste($event, this.milestoneForm.Betreff, 200)"></kendo-textbox>
      </kendo-formfield>

      <kendo-formfield class="text" showHints="initial">
        <kendo-label class="form-label" text="{{'schedule-data.dialog.location' | translate}}"
          [infotooltip]="'meilenstein.ort'" [for]="ort"></kendo-label>
        <kendo-textbox #ort formControlName="ort" appinfotext="ort" [maxlength]="200" [appinfotext]="'meilenstein.ort'"
          (paste)="this.textBoxService.onPaste($event, this.milestoneForm.Ort, 200)"></kendo-textbox>
      </kendo-formfield>

      <kendo-formfield class="text" showHints="initial">
        <kendo-label class="form-label" text="{{'schedule-data.dialog.datePlan' | translate}} *"
          [infotooltip]="'meilenstein.datumplan'" [for]="datumPlan"></kendo-label>
        <kendo-datepicker #datumPlan formControlName="datumPlan" appinfotext="Datum Plan" [appinfotext]="'meilenstein.datumplan'"
          [format]="dateFormat" [incompleteDateValidation]="true" [disabled]="isUpdatedInProjektBericht">
        </kendo-datepicker>
      </kendo-formfield>

      <kendo-formfield class="text" showHints="initial">
        <kendo-label class="form-label" text="{{'schedule-data.dialog.dateActual' | translate}}"
          [infotooltip]="'meilenstein.datumist'" [for]="datumIst"></kendo-label>
        <kendo-datepicker #datumIst formControlName="datumIst" appinfotext="Datum Ist" [appinfotext]="'meilenstein.datumist'"
          [format]="dateFormat" [incompleteDateValidation]="true" [disabled]="!isUpdatedInProjektBericht">
        </kendo-datepicker>
      </kendo-formfield>

      <kendo-formfield class="text sm:col-span-2" showHints="initial">
        <kendo-label class="form-label" text="{{'schedule-data.dialog.description' | translate}}"
          [infotooltip]="'meilenstein.beschreibung'" [for]="beschreibung"></kendo-label>
        <kendo-textarea #beschreibung formControlName="beschreibung" appinfotext="beschreibung"
          [attr.aria-label]="'meilenstein.beschreibung' | translate" [maxlength]="400" [rows]="8"
          [appinfotext]="'meilenstein.beschreibung'"
          (paste)="this.textBoxService.onPaste($event, this.milestoneForm.Beschreibung, 400)"></kendo-textarea>
      </kendo-formfield>

      <div class="milestone-button-group">
        <button kendoButton class="cancel-button" (click)="cancelForm()">
            {{ 'schedule-data.dialog.cancel' | translate }}
          </button>
          <button kendoButton class="confirm-button" (click)="saveMilestone()" [disabled]="!milestoneForm.valid">
            {{ 'question.save' | translate }}
        </button>
      </div>
    </div>
  </form>

</form-layout>
